import React, { useState } from 'react';
import { Autocomplete, Chip,  Grid, Stack, TextField } from '@mui/material';
import MaterialTypography from '../MaterialTypography';
import MaterialInput from '../MaterialInput';

const NewFolder = ({ newFolder,teamMembersData,handleMemberChange,handleReadMemberChange,setNewFolder }) => {


  // Example static team member data
  // const teamMembersData = [
  //   { id: 1, employee_name: 'Alice', team: 'Design' },
  //   { id: 2, employee_name: 'Bob', team: 'Development' },
  //   { id: 3, employee_name: 'Charlie', team: 'Marketing' },
  //   { id: 4, employee_name: 'David', team: 'QA' },
  // ];

  // Handlers for Autocomplete changes
  // const handleMemberChange = (event, newValue) => {
  //   setNewFolder((prev) => ({ ...prev, writePermission: newValue }));
  // };

  // const handleReadMemberChange = (event, newValue) => {
  //   setNewFolder((prev) => ({ ...prev, readPermission: newValue }));
  // };

  return (
    <Grid container direction="column" spacing={2}>
      {/* Folder Name */}
      <Grid size={{ xs: 12, sm: 12, md: 12 }}>
        <Stack direction="column" spacing={1}>
          <MaterialTypography variant="caption" color="dark">
            Folder Name
          </MaterialTypography>
          <MaterialInput
            variant="standard"
            value={newFolder.name}
            
            onChange={(e) =>{
              const value = e.target.value;
              if(/^[a-zA-Z0-9 ]*$/.test(value)){
                 setNewFolder({...newFolder,name:value})
              }
              }}
            placeholder="Enter folder name"
            autoFocus
            fullWidth
          />
        </Stack>
      </Grid>

      {/* Write Permission */}
      <Grid size={{ xs: 12, sm: 12, md: 12 }}>
        <Stack direction="column" spacing={1}>
          <MaterialTypography variant="caption" color="dark">
            Write Permission
          </MaterialTypography>
          <Autocomplete
            multiple
            id="tags-outlined"
            options={teamMembersData || []}
            getOptionLabel={(option) =>
              `${option.employee_name || ""} (${option.team || "No Team"})`
            }
            value={newFolder.writePermission || []}
            onChange={handleMemberChange}
            filterSelectedOptions
            renderTags={(selected, getTagProps) =>
              selected.map((option, index) => (
                <Chip
                  key={option.id || index}
                  label={`${option.employee_name} (${option.team || "No Team"})`}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField {...params} placeholder="Add write members" />
            )}
          />
        </Stack>
      </Grid>

      {/* Read Permission */}
      <Grid size={{xs:12,sm:12,md:12}}>
        <Stack direction="column" spacing={1}>
          <MaterialTypography variant="caption" color="dark">
            Read Permission
          </MaterialTypography>
          <Autocomplete
            multiple
            id='tags-outlined'
            options={teamMembersData || []}
            getOptionLabel={(option) =>
              `${option.employee_name || ""} (${option.team || "No Team"})`
            }
            value={newFolder.readPermission || []}
            onChange={handleReadMemberChange}
            filterSelectedOptions
            renderTags={(selected, getTagProps) =>
              selected.map((option, index) => (
                <Chip
                  key={option.id || index}
                  label={`${option.employee_name || ""} (${option.team || "No Team"})`}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField {...params} placeholder="Add read members" />
            )}
          />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default NewFolder;
